import React from 'react';
import './Editable.css';
import 'react-phone-number-input/style.css'
import '../../App/Styles.css'
import {Editable, EditableProps} from "./Editable";
import PhoneInput from "react-phone-number-input";
import {useEditable} from "./EditableContext";
import {space} from "../../provider_api";


/**
 * Shows a phone number and verified status but this doesn't have the widget
 * to verify the thing (TODO Hack, consolidate these)
 */
export const EditablePhoneInputField = <EnclosingType extends object>(props: EditableProps<EnclosingType, string>) => {

  const {editing, value, setValue} = useEditable(props);
  
  if (editing && !props.immutable) {
    return <Editable {...props}>
      <PhoneInput
          placeholder="Enter phone number"
          defaultCountry={'US'}
          value={value ?? ''}
          onChange={v => {
            setValue(v as string);
          }}/>
    </Editable>

  } else {

    return <Editable {...props}>
      <div className={'EditableNotEditing'}>
        {value}
      </div>
    </Editable>
  }

}